import React, { useState } from 'react';
import {
  Divider,
  Typography,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles';
import './style.css';
import logo from '../../../../assets/Images/edit.png';

export default function Footer() {
  const classes = useStyles();
  const currentYear = new Date().getFullYear().toString();
  const [impressumOpen, setImpressumOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* First Column */}
        <div className="footer-column1">
          <img src={logo} alt="Logo" className="logo" />
          <div className="content-description">
            <p>
              We are thrilled to have you here. Zineflix is your ultimate
              destination for all your movie booking needs. Whether you're
              looking to catch the latest blockbuster, enjoy a classic film, or
              discover indie gems, we've got you covered. Our user-friendly
              platform ensures a seamless and enjoyable experience, from
              browsing movie listings to securing your tickets.
            </p>
          </div>
          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=100071265075336"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://x.com/Zineflix?t=JoN3UyXp6mI5hkM2QatvZQ&s=09"
              aria-label="Twitter/X"
              target="_blank"
              rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.instagram.com/zineflixofficial?utm_source=qr&igsh=MXI1emduaTY3NXF2dw=="
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* Second Column */}
        <div className="footer-column2">
          {/* First Row */}
          <div className="footer-row">
            {/* Phone */}
            <div className="footer-column3">
              <div className="icon-container phone">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <h4>Phone</h4>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href="tel:+4917656806226">
                  +49 176 56806226
                </a>
              </div>
            </div>
            {/* Address */}
            <div className="footer-column3">
              <div className="icon-container">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <h4>Address</h4>
                <p>Ahornstraße 80, 65933 Frankfurt am Main, Deutschland</p>
              </div>
            </div>
            {/* Email */}
            <div className="footer-column3">
              <div className="icon-container">
                <i className="far fa-envelope"></i>
              </div>
              <div>
                <h4>Email</h4>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href="mailto:contact@zineflix.com">
                  contact@zineflix.com
                </a>
              </div>
            </div>
          </div>

          <hr className="row-divider" />

          {/* Second Row */}
          <div className="footer-row">
            <div className="footer-column4">
              <h4>Company</h4>
              <ul className="footer-list">
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">About Us</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Our Services</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Privacy Policy</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Affiliate Program</span>
                </li>
              </ul>
            </div>

            <div className="footer-column4">
              <h4>Pages</h4>
              <ul className="footer-list">
                <li>Page 1</li>
                <li>Page 2</li>
                <li>Page 3</li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <button
                    type="button"
                    className="icon-text linklike-button"
                    onClick={() => setImpressumOpen(true)}
                    aria-haspopup="dialog"
                    aria-controls="impressum-dialog">
                    Impressum
                  </button>
                </li>
              </ul>
            </div>

            <div className="footer-column4">
              <h4>Newsletter</h4>
              <p>
                Sign up for our newsletter to get updated information, news, and
                free insights.
              </p>
              <div className="newsletter-input-container">
                <input
                  type="email"
                  className="newsletter-input"
                  placeholder="Enter your email"
                  aria-label="Email address"
                />
                <button className="newsletter-button">Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Divider className="footer-divider" />

      <div className="footer-copyright">
        <div className="copyright-text">
          © {currentYear} zineflix.com All rights reserved.
        </div>
        <div className="footer-links">
          <Link
            href="https://www.matrixmantra.lk/"
            target="_blank"
            rel="noopener noreferrer">
            Web Design &amp; Development by Matrix Mantra
          </Link>
        </div>
      </div>

      {/* Impressum Dialog */}
      <Dialog
        id="impressum-dialog"
        open={impressumOpen}
        onClose={() => setImpressumOpen(false)}
        aria-labelledby="impressum-title"
        fullWidth
        maxWidth="sm">
        <DialogTitle
          disableTypography
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <Typography variant="h6" id="impressum-title">
            Impressum
          </Typography>
          <IconButton
            aria-label="Close Impressum"
            onClick={() => setImpressumOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <section>
            <Typography variant="subtitle1" component="h3" gutterBottom>
              Angaben gemäß § 5 TMG
            </Typography>
            <Typography
              component="address"
              style={{ fontStyle: 'normal', lineHeight: 1.8 }}>
              <strong>Zineflix</strong>
              <br />
              Hr. Sivarsan Tharmaratnam
              <br />
              Ahornstraße 80
              <br />
              65933 Frankfurt am Main
              <br />
              Deutschland
            </Typography>
          </section>

          <section style={{ marginTop: 16 }}>
            <Typography variant="subtitle1" component="h3" gutterBottom>
              Kontakt
            </Typography>
            <Typography>
              Telefon: <a href="tel:+4917656806226">+49 176 56806226</a>
              <br />
              E‑Mail:{' '}
              <a href="mailto:contact@zineflix.com">contact@zineflix.com</a>
              <br />
              Website:{' '}
              <a
                href="https://www.zineflix.com"
                target="_blank"
                rel="noopener noreferrer">
                www.zineflix.com
              </a>
            </Typography>
          </section>

          <section style={{ marginTop: 16 }}>
            <Typography variant="subtitle1" component="h3" gutterBottom>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </Typography>
            <Typography
              component="address"
              style={{ fontStyle: 'normal', lineHeight: 1.8 }}>
              Hr. Sivarsan Tharmaratnam
              <br />
              Ahornstraße 80
              <br />
              65933 Frankfurt am Main
              <br />
              Deutschland
            </Typography>
          </section>
        </DialogContent>
      </Dialog>
    </footer>
  );
}
